import { openTextMessagesModal } from "../actions/portal.action";
import { LOGOUT } from "./account.reducer";

export const GET_SESSIONS_LOADING = "GET_SESSIONS_LOADING";
export const GET_SESSIONS_LOADING_SUCCESSFUL =
  "GET_SESSIONS_LOADING_SUCCESSFUL";
export const GET_SESSIONS_LOADING_FAIL = "GET_SESSIONS_LOADING_FAIL";

export const GET_MATERIALS_LOADING = "GET_MATERIALS_LOADING";
export const GET_MATERIALS_LOADING_SUCCESSFUL =
  "GET_MATERIALS_LOADING_SUCCESSFUL";
export const GET_MATERIALS_LOADING_FAIL = "GET_MATERIALS_LOADING_FAIL";

export const GET_REQUEST_LOADING = "GET_REQUEST_LOADING";
export const GET_REQUEST_LOADING_SUCCESSFUL = "GET_REQUEST_LOADING_SUCCESSFUL";
export const GET_REQUEST_LOADING_FAIL = "GET_REQUEST_LOADING_FAIL";

export const GET_SUBMITTED_LOADING = "GET_REQUEST_LOADING";
export const GET_SUBMITTED_LOADING_SUCCESSFUL =
  "GET_REQUEST_LOADING_SUCCESSFUL";
export const GET_SUBMITTED_LOADING_FAIL = "GET_REQUEST_LOADING_FAIL";

export const SEND_REQUEST_LOADING = "SEND_REQUEST_LOADING";
export const SEND_REQUEST_LOADING_SUCCESSFUL =
  "SEND_REQUEST_LOADING_SUCCESSFUL";
export const SEND_REQUEST_LOADING_FAIL = "SEND_REQUEST_LOADING_FAIL";

export const REQUEST_MODAL_OPEN = "REQUEST_MODAL_OPEN";
export const REQUEST_MODAL_CLOSE = "REQUEST_MODAL_CLOSE";

export const ASSESSMENT_MODAL_OPEN = "ASSESSMENT_MODAL_OPEN";
export const ASSESSMENT_MODAL_CLOSE = "ASSESSMENT_MODAL_CLOSE";

export const TEXT_MESSAGES_MODAL_OPEN = "TEXT_MESSAGES_MODAL_OPEN";
export const TEXT_MESSAGES_MODAL_CLOSE = "TEXT_MESSAGES_MODAL_CLOSE";
export const DISCLAIMER_MODAL_OPEN = "DISCLAIMER_MODAL_OPEN";
export const DISCLAIMER_MODAL_CLOSE = "DISCLAIMER_MODAL_CLOSE";
export const VERIFICATION_MODAL_OPEN = "VERIFICATION_MODAL_OPEN";
export const VERIFICATION_MODAL_CLOSE = "VERIFICATION_MODAL_CLOSE";

export const GET_ASSESSMENTS_SUCCESS = "GET_ASSESSMENTS_SUCCESS";
export const GET_ASSESSMENTS_FAIL = "GET_ASSESSMENTS_FAIL";

export const CHECK_SMS_STATUS = "CHECK_SMS_STATUS";
export const CHECK_SMS_STATUS_SUCCESSFUL = "CHECK_SMS_STATUS_SUCCESSFUL";
export const CHECK_SMS_STATUS_FAIL = "CHECK_SMS_STATUS_FAIL";

export const SET_SMS_DATA = "SET_SMS_DATA";
export const SET_SMS_DATA_SUCCESSFUL = "SET_SMS_DATA_SUCCESSFUL";
export const SET_SMS_DATA_FAIL = "SET_SMS_DATA_FAIL";

export const CHECK_SMS_VERIFICATION_CODE = "CHECK_SMS_VERIFICATION_CODE";
export const CHECK_SMS_VERIFICATION_CODE_SUCCESSFUL =
  "CHECK_SMS_VERIFICATION_CODE_SUCCESSFUL";
export const CHECK_SMS_VERIFICATION_CODE_FAIL =
  "CHECK_SMS_VERIFICATION_CODE_FAIL";

export const SET_SECONDS_LEFT = "SET_SECONDS_LEFT";

const portalInitialState = {
  sessions: [],
  sessionsLoading: false,
  materials: [],
  materialsLoading: false,
  request: [],
  requestLoading: false,
  submitted: [],
  submittedLoading: false,
  sendRequest: [],
  sendRequestLoading: false,
  assessments: [],
  loading: true,
  openRequestModal: false,
  openAssessmentModal: false,
  openTextMessagesModal: false,
  smsDataLoading: false,
  smsData: [],
  setSMSDataLoading: false,
  setSMSData: null,
  openDisclaimerModal: false,
  openVerificationModal: false,
  secondsLeft: null,
};

const portalReducer = (state = portalInitialState, action) => {
  switch (action.type) {
    case LOGOUT:
      return {
        ...state,
        smsData: [],
      };
    case GET_SESSIONS_LOADING:
      return {
        ...state,
        //sessions:[],
        sessionsLoading: true,
      };
    case GET_SESSIONS_LOADING_SUCCESSFUL:
      return {
        ...state,
        sessions: Array.isArray(action.payload) ? action.payload : (action.payload?.Result ?? action.payload ?? []),
        sessionsLoading: false,
      };
    case GET_SESSIONS_LOADING_FAIL:
      return {
        ...state,
        sessionsLoading: false,
      };

    case GET_MATERIALS_LOADING:
      return {
        ...state,
        materials: [],
        materialsLoading: true,
      };
    case GET_MATERIALS_LOADING_SUCCESSFUL:
      return {
        ...state,
        materials: action.payload,
        materialsLoading: false,
      };
    case GET_MATERIALS_LOADING_FAIL:
      return {
        ...state,
        materials: [],
        materialsLoading: false,
      };
    case GET_REQUEST_LOADING:
      return {
        ...state,
        request: [],
        requestLoading: true,
      };
    case GET_REQUEST_LOADING_SUCCESSFUL:
      return {
        ...state,
        request: action.payload,
        requestLoading: false,
      };
    case GET_REQUEST_LOADING_FAIL:
      return {
        ...state,
        request: [],
        requestLoading: false,
      };

    case GET_SUBMITTED_LOADING:
      return {
        ...state,
        submitted: [],
        submittedLoading: true,
      };
    case GET_SUBMITTED_LOADING_SUCCESSFUL:
      return {
        ...state,
        submitted: action.payload,
        submittedLoading: false,
      };
    case GET_SUBMITTED_LOADING_FAIL:
      return {
        ...state,
        submitted: [],
        submittedLoading: false,
      };

    case SEND_REQUEST_LOADING:
      return {
        ...state,
        sendRequestLoading: true,
      };
    case SEND_REQUEST_LOADING_SUCCESSFUL:
      return {
        ...state,
        sendRequest: action.payload,
        sendRequestLoading: false,
      };
    case SEND_REQUEST_LOADING_FAIL:
      return {
        ...state,
        sendRequestLoading: false,
      };

    case REQUEST_MODAL_OPEN:
      return {
        ...state,
        openRequestModal: true,
      };
    case REQUEST_MODAL_CLOSE:
      return {
        ...state,
        openRequestModal: false,
      };
    case ASSESSMENT_MODAL_OPEN:
      return {
        ...state,
        openAssessmentModal: true,
      };
    case ASSESSMENT_MODAL_CLOSE:
      return {
        ...state,
        openAssessmentModal: false,
      };
    case TEXT_MESSAGES_MODAL_OPEN:
      return {
        ...state,
        openTextMessagesModal: true,
      };
    case TEXT_MESSAGES_MODAL_CLOSE:
      return {
        ...state,
        openTextMessagesModal: false,
      };
    case DISCLAIMER_MODAL_OPEN:
      return {
        ...state,
        openDisclaimerModal: true,
      };
    case DISCLAIMER_MODAL_CLOSE:
      return {
        ...state,
        openDisclaimerModal: false,
      };
    case VERIFICATION_MODAL_OPEN:
      return {
        ...state,
        openVerificationModal: true,
      };
    case VERIFICATION_MODAL_CLOSE:
      return {
        ...state,
        openVerificationModal: false,
      };
    case GET_ASSESSMENTS_SUCCESS: {
      const payload = action.payload;
      const normalized = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.items)
          ? payload.items
          : Array.isArray(payload?.data)
            ? payload.data
            : Array.isArray(payload?.assessments)
              ? payload.assessments
              : Array.isArray(payload?.results)
                ? payload.results
                : [];
      return { ...state, loading: false, assessments: normalized };
    }
    case GET_ASSESSMENTS_FAIL:
      return {
        ...state,
        loading: false,
        assessments: [],
        error: action.payload,
      };
    case CHECK_SMS_STATUS:
      return {
        ...state,
        // smsData: [],
        smsDataLoading: true,
      };
    case CHECK_SMS_STATUS_SUCCESSFUL:
      return {
        ...state,
        smsData: action.payload,
        smsDataLoading: false,
      };
    case CHECK_SMS_STATUS_FAIL:
      return {
        ...state,
        smsData: [],
        smsDataLoading: false,
      };
    case SET_SMS_DATA:
      return {
        ...state,
        setSMSDataLoading: true,
      };
    case SET_SMS_DATA_SUCCESSFUL:
      return {
        ...state,
        smsData: action.payload,
        setSMSData: action.payload,
        setSMSDataLoading: false,
      };
    case SET_SMS_DATA_FAIL:
      return {
        ...state,
        setSMSDataLoading: false,
      };
    case SET_SECONDS_LEFT:
      return {
        ...state,
        secondsLeft: action.payload,
      };
    default: {
      return state;
    }
  }
};

export default portalReducer;
